import React from "react";
import TimeUtils from "../../utils/TimeUtils";

export function DateTimeRenderer({ cellData }) {
  if (!cellData) {
    return <div>-</div>;
  }

  return TimeUtils.convertDateToHumanReadable(cellData);
}

export function CurrencyRenderer({ cellData, currency, style = {} }) {
  const floatValue = parseFloat(cellData);
  if (isNaN(floatValue)) {
    return <div style={style}>-</div>;
  }
  const locale = navigator.languages[0];
  const currencyCode = currency || "USD";
  const negativeClass = floatValue < 0 ? "negative" : null;
  let formattedData = floatValue.toLocaleString(locale, {
    style: "currency",
    currency: currencyCode,
  });
  return (
    <div className={negativeClass} style={style}>
      {formattedData}
    </div>
  );
}

export function CartNoteRenderer({ cellData, noteField }) {
  try {
    const noteObj = JSON.parse(cellData);
    if (noteField === "note") {
      return noteObj.note;
    }
    return noteObj.customFields?.[noteField];
  } catch (err) {
    return noteField === "note" ? cellData : null;
  }
}

export function TextInputFilter({ value, setValue, title, ...rest }) {
  return (
    <input
      type="text"
      value={value === null || value === undefined ? "" : value}
      onChange={(event) => setValue(event.target.value)}
      title={title}
      {...rest}
    />
  );
}

export function NumberInputFilter({ value, setValue, title, ...rest }) {
  return (
    <input
      title={title}
      type="text"
      value={value === null || value === undefined ? "" : value}
      onChange={(event) => {
        const value = event.target.value;
        if (!value || !value.length) {
          setValue(null);
          return;
        }
        const number = parseInt(value, 10);
        if (isNaN(number)) {
          return;
        }
        setValue(number);
      }}
      {...rest}
    />
  );
}
